/* eslint-disable multiline-ternary */
/* eslint-disable max-len */
import React from "react";
import {
  Divider,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import LinkButton from "../../../components/Buttons/LinkButton";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import HttpService from "../../../services/HttpService";
import TitleLayout from "../../../components/layout/TitleLayout";
import { Box } from "@mui/system";
import moment from "moment";
import PageviewOutlinedIcon from "@mui/icons-material/PageviewOutlined";
import Theme from "../../../Themes/main.theme";
import { useUserDbInfo } from "../../../hooks/UserInfo";
import UserService from "../../../services/UserService";
import { FromScratchPermissions } from "../../../lib/permissions";
import TableGridWithFilters from "../../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters";
interface IPreviewFormIncomingProps {
  applications: Record<string, unknown>[];
  isLoading: boolean;
  _pageSize: number;
  _page: number;
  setPageSize: (a: number) => void;
  setPage: (a: number) => void;
  total_count: number;
}

function AdminPreviewApplications(props: IPreviewFormIncomingProps) {
  const navigate = useNavigate();
  const [rows, setRows] = React.useState<any[]>([]);
  const [shouldRefresh, setShouldRefresh] = React.useState(false);

  const { userDbInfo, loading } = useUserDbInfo();

  const canInteractWithFormBuilderForm = (userInfo: any, row: any) => {
    if (
      UserService.hasRole([
        FromScratchPermissions.PermissionsInternalApplicationFromScratchAll,
      ])
    ) {
      return true;
    }

    if (
      UserService.hasRole([
        FromScratchPermissions.PermissionsInternalApplicationFromScratchMyOrg,
      ])
    )
      return (
        row.form_form.administrative_unit_id == userInfo.administrative_unit_id
      );

    return false;
  };

  const updateFormPublished = async (id: number, is_published: boolean) => {
    try {
      await HttpService.getAxiosClient().patch(`/forms/publish/${id}/`, {
        is_published: !is_published,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSwitchChange = async (row: any) => {
    await updateFormPublished(row.id, row.appl_title_naming.is_published);
    setShouldRefresh(!shouldRefresh);

    const newRows = rows.map((r) => {
      if (r.id == row.id) {
        return {
          ...r,
          appl_title_naming: {
            ...r.appl_title_naming,
            is_published: !r.appl_title_naming.is_published,
          },
        };
      }
      return r;
    });
    setRows(newRows);
  };

  React.useEffect(() => {
    setRows(props.applications);
  }, [props.applications]);

  const columns = [
    { field: "id", headerName: "ID", minWidth: 70 },
    {
      field: "title",
      headerName: "Κατηγορία Αιτήματος",
      minWidth: 495,
      renderCell: ({ row }: any) => (
        <Typography>{row.appl_title_naming.title}</Typography>
      ),
    },
    {
      field: "is_published",
      headerName: "Publish/Unpublish",
      minWidth: 190,
      renderCell: ({ row }: any) => (
        <Switch
          disabled={!canInteractWithFormBuilderForm(userDbInfo, row)}
          onChange={() => handleSwitchChange(row)}
          checked={row.appl_title_naming.is_published}
        />
      ),
    },
    {
      field: "date_created",
      headerName: "Ημερομηνία Δημιουργίας",
      minWidth: 295,
      renderCell: ({ row }: any) => row.appl_title_naming.date_created
        ? moment(row.appl_title_naming.date_created).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      field: "actions",
      headerName: "Ενέργειες",
      minWidth: 130,
      sortable: false,
      renderCell: ({ row }: any) => {
        if (loading) return null;

        return !row.isReactApplication ? (
          <>
            <Tooltip PopperProps={{ disablePortal: true }} title='Προβολή'>
              <IconButton
                color='primary'
                onClick={() =>
                  navigate(
                    `/admin/applications/${row.appl_section.form_form.find(
                      (x: any) => x.title_naming_id == row.id
                    ).id
                    }`
                  )
                }
              >
                <PageviewOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip PopperProps={{ disablePortal: true }} title='Επεξεργασία'>          
              <IconButton
                disabled={false}
                color='primary'
                onClick={() =>
                  navigate(`/admin/applications/new-form/edit/${row?.form_form?.id}`)
                }
              >
                {" "}
                {/* omeka_id instead of id */}
                <EditIcon />
              </IconButton>
            </Tooltip>
            {/* <Tooltip
              PopperProps={{ disablePortal: true }}
              title='Διαγραφή'>
              <IconButton disabled={!canInteractWithFormBuilderForm(userDbInfo, row)} color='error'>
                <DeleteIcon />
              </IconButton>
            </Tooltip> */}
          </>
        ) : (
          "-"
        );
      },
    },
  ];

  return (
    <>
      <Typography
        variant='h2'
        sx={{ my: 2, mt: 4 }}
        color={Theme.labelColor?.main}
      >
        Διαχείριση Αιτημάτων
      </Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
      <TitleLayout>
        <LinkButton
          link='/admin/applications/new-form'
          color='primary'
          variant='contained'
        >
          {" "}
          Νέο Αίτημα/Φόρμα
        </LinkButton>
      </TitleLayout>

      <Box height='3px'>
        <TableGridWithFilters
          reFetch={shouldRefresh}
          fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/forms`}
          sortingMode='server'
          sortModel={[{ field: "id", sort: "asc" }]}
          paginationMode='server'
          hideFilters={true}
          columns={columns}
          pageSize={props._pageSize}
          rowsPerPageOptions={[10, 30, 50, 100]}
        />
      </Box>
    </>
  );
}

export default AdminPreviewApplications;
